var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChemistry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5DDDD3"
    },
    d: "M255.999,0c141.386,0,256,114.614,256,256s-114.614,256-256,256C114.615,512,0.001,397.386,0.001,256 C0.001,114.612,114.615,0,255.999,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M118.461,200.171h68.304v184.711c0,18.781-15.368,34.153-34.153,34.153s-34.153-15.368-34.153-34.153 V200.171H118.461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15BDB1"
    },
    d: "M128.79,280.364v104.518c0,13.081,10.74,23.823,23.821,23.823c13.084,0,23.823-10.74,23.823-23.823 V280.364H128.79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M115.032,191.594h75.163c4.718,0,8.577,3.858,8.577,8.577v0.002c0,4.718-3.858,8.575-8.577,8.575 h-75.163c-4.718,0-8.577-3.858-8.577-8.575v-0.002C106.455,195.453,110.314,191.594,115.032,191.594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M198.772,200.171v0.002c0,4.718-3.858,8.575-8.577,8.575h-75.163c-4.718,0-8.577-3.858-8.577-8.575 v-0.002H198.772z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M293.254,95.181v142.792l101.33,187.171c15.176,28.03-2.952,44.661-34.625,44.661H254.91H149.856 c-31.673,0-49.81-16.607-34.625-44.661l101.335-187.171V95.181H293.254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M496.336,132.621v175.303H379.289V132.621C364.149,132.621,504.476,132.621,496.336,132.621z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5B61"
    },
    d: "M432.814,132.621V37.637h-50.105c-1.951,0-3.537-1.585-3.537-3.537V12.063h-13.511v60.086 c0,1.951-1.583,3.537-3.534,3.537h-21.208c-1.951,0-3.537-1.585-3.537-3.537V40.754h-78.936v54.427h-7.073V37.22 c0-1.951,1.585-3.537,3.537-3.537h86.009c1.953,0,3.537,1.585,3.537,3.537v31.395h14.135V8.528c0-1.951,1.583-3.537,3.537-3.537 h20.584c1.951,0,3.537,1.585,3.537,3.537v22.037h50.105c1.951,0,3.537,1.583,3.537,3.537v98.521h-7.073L432.814,132.621z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8CACC"
    },
    d: "M439.885,155.79c0,1.951-1.585,3.537-3.537,3.537s-3.537-1.585-3.537-3.537v-23.166h7.073V155.79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C8CACC"
    },
    d: "M258.444,95.181v49.016c0,1.951-1.585,3.537-3.537,3.537c-1.951,0-3.537-1.585-3.537-3.537V95.181 H258.444z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5B61"
    },
    d: "M207.226,291.081L128.66,431.715c-1.887,3.861-5.031,11.659-2.509,15.921 c3.631,6.136,17.603,7.221,23.704,7.221H359.96c6.103,0,20.066-1.087,23.702-7.227c2.52-4.262-0.615-12.054-2.507-15.915 l-78.565-140.634c-39.273-8.731-56.089,12.475-95.362,0H207.226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M379.289,118.79h-7.051v13.831h131.146V118.79h-7.051H379.287H379.289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#20D0C2"
    },
    d: "M391.524,178.908c64.908-11.172,63.843,14.365,92.573,0v119.174h-92.573V178.908z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M391.524,137.408h11.891v3.989h-11.891V137.408z M391.524,294.567L391.524,294.567h5.946v3.991 h-5.946V294.567z M391.524,285.324L391.524,285.324h11.891v3.991h-11.891V285.324z M391.524,276.077L391.524,276.077h5.946v3.991 h-5.946V276.077z M391.524,266.832L391.524,266.832h11.891v3.991h-11.891V266.832z M391.524,257.587L391.524,257.587h5.946v3.991 h-5.946V257.587z M391.524,248.345L391.524,248.345h11.891v3.989h-11.891V248.345z M391.524,239.1L391.524,239.1h5.946v3.991 h-5.946V239.1z M391.524,229.855L391.524,229.855h11.891v3.991h-11.891V229.855z M391.524,220.608L391.524,220.608h5.946v3.993 h-5.946V220.608z M391.524,211.365L391.524,211.365h11.891v3.991h-11.891V211.365z M391.524,202.12L391.524,202.12h5.946v3.991 h-5.946V202.12z M391.524,192.878L391.524,192.878h11.891v3.989h-11.891V192.878z M391.524,183.633L391.524,183.633h5.946v3.991 h-5.946V183.633z M391.524,174.388L391.524,174.388h11.891v3.991h-11.891V174.388z M391.524,165.143L391.524,165.143h5.946v3.991 h-5.946V165.143z M391.524,155.898L391.524,155.898h11.891v3.991h-11.891V155.898z M391.524,146.653L391.524,146.653h5.946v3.991 h-5.946V146.653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M128.79,226.283h11.893v3.991H128.79V226.283z M128.79,383.442L128.79,383.442h5.946v3.991h-5.946 V383.442z M128.79,374.197L128.79,374.197h11.893v3.991H128.79V374.197z M128.79,364.952L128.79,364.952h5.946v3.991h-5.946 V364.952z M128.79,355.707L128.79,355.707h11.893v3.991H128.79V355.707z M128.79,346.465L128.79,346.465h5.946v3.991h-5.946 V346.465z M128.79,337.222L128.79,337.222h11.893v3.991H128.79V337.222z M128.79,327.975L128.79,327.975h5.946v3.991h-5.946 V327.975z M128.79,318.73L128.79,318.73h11.893v3.991H128.79V318.73z M128.79,309.485L128.79,309.485h5.946v3.991h-5.946V309.485z  M128.79,300.242L128.79,300.242h11.893v3.989H128.79V300.242z M128.79,290.997L128.79,290.997h5.946v3.989h-5.946V290.997z  M128.79,281.753L128.79,281.753h11.893v3.991H128.79V281.753z M128.79,272.508L128.79,272.508h5.946v3.991h-5.946V272.508z  M128.79,263.263L128.79,263.263h11.893v3.991H128.79V263.263z M128.79,254.018L128.79,254.018h5.946v3.991h-5.946V254.018z  M128.79,244.773L128.79,244.773h11.893v3.991H128.79V244.773z M128.79,235.53L128.79,235.53h5.946v3.991h-5.946V235.53z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#20D0C2"
    },
    d: "M110.195,104.247c7.064,0,12.79,5.726,12.79,12.793c0,7.064-5.726,12.793-12.79,12.793 c-7.067,0-12.795-5.728-12.795-12.793C97.4,109.973,103.128,104.247,110.195,104.247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5B61"
    },
    d: "M132.373,152.194c4.564,0,8.264,3.7,8.264,8.264s-3.7,8.264-8.264,8.264s-8.266-3.7-8.266-8.264 S127.809,152.194,132.373,152.194z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M129.247,67.201c4.996,0,9.044,4.048,9.044,9.044s-4.048,9.044-9.044,9.044 c-4.994,0-9.042-4.048-9.042-9.044S124.253,67.201,129.247,67.201z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M157.229,165.399c3.102,0,5.614,2.514,5.614,5.616c0,3.1-2.511,5.611-5.614,5.611 c-3.1,0-5.614-2.511-5.614-5.611C151.615,167.912,154.129,165.399,157.229,165.399z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBB429"
    },
    d: "M159.186,118.614c5.885,0,10.654,4.769,10.654,10.654c0,5.883-4.769,10.652-10.654,10.652 c-5.883,0-10.652-4.769-10.652-10.652C148.535,123.383,153.304,118.614,159.186,118.614z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M236.815,344.447c6.29,0,11.392,5.1,11.392,11.392c0,6.29-5.102,11.392-11.392,11.392 c-6.293,0-11.392-5.102-11.392-11.392C225.422,349.547,230.522,344.447,236.815,344.447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M186.008,397.328c4.564,0,8.264,3.7,8.264,8.264c0,4.566-3.7,8.266-8.264,8.266 c-4.566,0-8.266-3.7-8.266-8.266C177.742,401.028,181.442,397.328,186.008,397.328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M311.475,351.326c4.617,0,8.356,3.742,8.356,8.354c0,4.615-3.739,8.356-8.356,8.356 c-4.615,0-8.354-3.742-8.354-8.356S306.862,351.326,311.475,351.326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M261.332,303.936c3.36,0,6.085,2.725,6.085,6.088c0,3.36-2.727,6.085-6.085,6.085 c-3.362,0-6.088-2.727-6.088-6.085C255.245,306.661,257.97,303.936,261.332,303.936z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M331.936,418.199c4.048,0,7.327,3.281,7.327,7.327s-3.279,7.327-7.327,7.327 c-4.046,0-7.327-3.281-7.327-7.327S327.89,418.199,331.936,418.199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M214.916,436.158c2.637,0,4.776,2.139,4.776,4.776s-2.139,4.776-4.776,4.776 s-4.776-2.139-4.776-4.776S212.279,436.158,214.916,436.158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M273.406,393.19c6.85,0,12.404,5.554,12.404,12.404c0,6.85-5.554,12.402-12.404,12.402 c-6.85,0-12.402-5.554-12.402-12.402C261.004,398.744,266.558,393.19,273.406,393.19z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#20D0C2"
    },
    d: "M253.984,159.011c2.864,0,5.186,2.322,5.186,5.186c0,2.862-2.322,5.184-5.186,5.184 c-2.862,0-5.184-2.322-5.184-5.184C248.8,161.333,251.122,159.011,253.984,159.011z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5B61"
    },
    d: "M249.563,188.739c5.565,0,10.078,4.513,10.078,10.078c0,5.565-4.513,10.076-10.078,10.076 c-5.565,0-10.076-4.513-10.076-10.076C239.487,193.252,243.998,188.739,249.563,188.739z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M216.563,75.128h-16.128c-13.189,0-13.189,20.053,0,20.053h16.128h76.689h16.126 c13.189,0,13.189-20.053,0-20.053h-16.126H216.563z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M216.563,95.181h-16.128c-5.494,0-10.021-4.504-10.021-10.019v-0.007h128.988v0.007 c0,5.492-4.527,10.019-10.023,10.019h-16.126H216.563z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M379.289,132.621h-7.051v-6.917h131.146v6.917h-7.051H379.287H379.289z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FBB429"
    },
    d: "M269.116,225.637c3.532,0,6.394,2.864,6.394,6.394c0,3.532-2.864,6.394-6.394,6.394 c-3.53,0-6.394-2.862-6.394-6.394C262.721,228.501,265.586,225.637,269.116,225.637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M245.1,249.139c7.69,0,13.928,6.235,13.928,13.928c0,7.69-6.238,13.926-13.928,13.926 s-13.928-6.235-13.928-13.926S237.408,249.139,245.1,249.139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#20D0C2"
    },
    d: "M277.536,266.806c1.766,0,3.199,1.431,3.199,3.197s-1.433,3.197-3.199,3.197 s-3.195-1.429-3.195-3.197C274.341,268.237,275.77,266.806,277.536,266.806z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M213.45,344.075c2.282,0,4.132,1.848,4.132,4.13s-1.85,4.134-4.132,4.134s-4.132-1.852-4.132-4.134 S211.168,344.075,213.45,344.075z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M125.289,122.14c3.1,0,5.614,2.511,5.614,5.614c0,3.1-2.514,5.614-5.614,5.614 c-3.102,0-5.614-2.514-5.614-5.614C119.676,124.651,122.187,122.14,125.289,122.14z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChemistry);
export default __webpack_public_path__ + "static/media/chemistry.6f4763d67324b6c28b0b016e4ab914e0.svg";
export { ForwardRef as ReactComponent };